import React from 'react';
import Logo from './elementer/Logo';
import Hamb from './elementer/Hamburger';
import { PilNesteGronn } from './elementer/PilNeste';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Bg from '../img/bil1_img8.JPG'

function Tilbud () {
    const addclass=()=>{
        document.querySelector("#tilbud").classList.toggle('tilbud__main--aktiv');
        document.querySelector("#knapp-tilbud").classList.toggle('tilbud__main--knapp-aktiv');
        document.querySelector("#kant-venstre-tilbud").classList.toggle('tilbud__main--kant-venstre-aktiv');
        document.querySelector("#kant-hoyre-tilbud").classList.toggle('tilbud__main--kant-hoyre-aktiv');
    }  
    const addclass2=()=>{
        document.querySelector("#tilbud2").classList.toggle('tilbud__main--aktiv');
        document.querySelector("#knapp-tilbud2").classList.toggle('tilbud__main--knapp-aktiv');
        document.querySelector("#kant-venstre-tilbud2").classList.toggle('tilbud__main--kant-venstre-aktiv');
        document.querySelector("#kant-hoyre-tilbud2").classList.toggle('tilbud__main--kant-hoyre-aktiv');
    }  
    return (
    <div className='tilbud' >
        <div className='tilbud__banner' style={{backgroundImage: `url(${Bg})`}} alt='bakgrunn'>
            <Logo />
            <Hamb />
        </div>
        <Col md={{ span: 8, offset: 2 }}>
            <Container  className='tilbud__objekt'>
                <Container>
                    <Row classname='tilbud__main--rad'>
                        <Col className='tilbud__main--ingress'>
                            <p style={{fontSize: "20px", marginTop: "20px", marginBottom: "50px", fontFamily: "Source code pro, monospace"}}>Vi tilbyr førerkortopplæring i klasse B i Hallingdal og Numedal og klasse BE i Hallingdal. Hos oss møter du moderne kjøretøy og undervisning som er tilpasset deg og dine behov. Her får du en trygg og praktisk vei til førerkortet – enten du skal ta det for første gang, eller bygge på med tilhenger.</p>                           
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <h1 className='tilbud__header'>FØRERKORT KLASSE B</h1>
                    <Row classname='tilbud__main--rad'>
                        <Col className='tilbud__main--ingress'>
                        <p>Vil du ut på veien med egen bil? Klasse B er for deg som skal ta førerkort for personbil.</p>                           
                        <p style={{paddingTop: '15px'}}>Vi tilbyr:</p>
                            <ul>
                                
                                <li className='tilbud__innrykk'>Individuell og trygg opplæring</li> 
                                <li className='tilbud__innrykk'>Moderne og lettkjørte biler</li>   
                                <li className='tilbud__innrykk'>Fokus på trafikksikkerhet og kjøreglede</li>   
                                <li className='tilbud__innrykk'>Tilpasset undervisning – vi møter deg der du er</li>   
                                <li className='tilbud__innrykk'>Tilgjengelig undervisning i både Hallingdal og Numedal.</li> 

                            </ul>
                            <p>Vårt mål er at du skal føle deg trygg, forberedt og klar til nullvisjon.</p>
                        </Col>
                    </Row>
                    <div className='tilbud__main--knapp' id='knapp-tilbud'>
                        <div className='tilbud__main--kant-venstre' id='kant-venstre-tilbud' />
                        <div onClick={addclass}>Priser</div>
                        <div className='tilbud__main--kant-hoyre' id='kant-hoyre-tilbud' />
                    </div>
                </Container>
                <Container className='tilbud__main tilbud__main--aktiv' id='tilbud'>
                    <Row className='tilbud__rad'>
                        <Col className='tilbud__tabell--container'>
                            <Table className='tilbud__tabell'>
                                <thead>
                                    <tr>
                                        <th>Timer</th>
                                        <th>Priser</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <td>Kjøretime (45 min)</td>
                                    <td>875,-</td>
                                </tbody>
                                <tbody>
                                    <td>Trinnvurdering trinn 2 (45 min)</td>
                                    <td>875,-</td>
                                </tbody>
                                <tbody>
                                    <td>Trinnvurdering trinn 3 (60 min)</td>
                                    <td>1300,-</td>
                                </tbody>
                                <tbody>
                                    <td>Sikkerhetskurs på øvingsbane (180 min)</td>
                                    <td>6900,-</td>
                                </tbody>
                                <tbody>
                                    <td>Sikkerhetskurs på vei (585 min)</td>
                                    <td>9900,-</td>
                                </tbody>
                                <tbody>
                                    <td>Leie av bil til førerprøve (70 min)</td>
                                    <td>2400,-</td>
                                </tbody>
                                <tbody>
                                    <td>Mørkedemo (180 min)</td>
                                    <td>1900,-</td>
                                </tbody>
                                <tbody>
                                    <td>Fakturagebyr</td>
                                    <td>99,-</td>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Container  className='tilbud__objekt tilbud__siste-objekt'>
                <Container>
                    <h1 className='tilbud__header'>FØRERKORT KLASSE BE - Bil med tilhenger</h1>
                    <Row classname='tilbud__main--rad'>
                        <Col className='tilbud__main--ingress'>
                            <p>Trenger du å kjøre med stor tilhenger – f.eks. hestehenger, båt eller arbeidsutstyr? Klasse BE gir deg lov til å kjøre bil med tilhenger over det klasse B tillater.</p>                           
                            <ul>
                                <p style={{paddingTop: '15px'}}>Vi tilbyr:</p>
                                <li className='tilbud__innrykk'>Effektiv og grundig opplæring</li> 
                                <li className='tilbud__innrykk'>Fokus på praktisk kjøring og sikkerhetskontroll</li>                                   
                            </ul>
                            <p>Passer perfekt for deg som har behov for tilhenger i jobb eller fritid.</p>
                        </Col>
                    </Row>
                    <div className='tilbud__main--knapp' id='knapp-tilbud2'>
                        <div className='tilbud__main--kant-venstre' id='kant-venstre-tilbud2' />
                        <div onClick={addclass2}>Priser</div>
                        <div className='tilbud__main--kant-hoyre' id='kant-hoyre-tilbud2' />
                    </div>
                </Container>
                <Container className='tilbud__main tilbud__main--aktiv' id='tilbud2'>
                    <Row className='tilbud__rad'>
                        <Col className='tilbud__tabell--container'>
                            <Table className='tilbud__tabell'>
                                <thead>
                                    <tr>
                                        <th>Timer</th>
                                        <th>Priser</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <td>Kjøretime (45 min)</td>
                                    <td>950,-</td>
                                </tbody>
                                <tbody>
                                    <td>Sikkerhetskurs på vei (135 min)</td>
                                    <td>3100,-</td>
                                </tbody>
                                <tbody>
                                    <td>Leie av bil og henger til førerprøve</td>
                                    <td>2500,-</td>
                                </tbody>
                                <tbody>
                                    <td>Fakturagebyr</td>
                                    <td>99,-</td>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </Col>
       {/*<Container className='tilbud__objekt tilbud__objekt--sist'>
            <Container>
                <p className='tilbud__header'>Førerkort klasse BE (tilhenger)</p>
                <Row classname='tilbud__main--rad'>
                    <Col className='tilbud__main--ingress'>
                        Eleven skal kjøre bil på en ansvarlig måte. Eleven skal ha de kunnskaper og ferdigheter, den selvinnsikt og risikoforståelse, som er nødvendig for å kjøre på en måte som: - er trafikksikker - gir god samhandling - fører til god trafikkavvikling - tar hensyn til helse, miljø og andres behov - er i samsvar med gjeldende regelverk. 
                    </Col>
                </Row>
            </Container>
            <Container className='tilbud__main'>
                <Row className='tilbud__rad'>
                    <Col className='tilbud__tabell--container'>
                        <Table className='tilbud__tabell'>
                            <thead>
                                <tr>
                                    <th>Timer</th>
                                    <th>Priser</th>
                                </tr>
                            </thead>
                            <tbody>
                                <td>Kjøretime</td>
                                <td>850,-</td>
                            </tbody>
                            <tbody>
                                <td>Sikkerhetskurs på vei</td>
                                <td>2600,-</td>
                            </tbody>
                            <tbody>
                                <td>leie bil og tilhenger til oppkjøring</td>
                                <td>2000,-</td>
                            </tbody>
                            <tbody>
                                <td>fakturagebyr</td>
                                <td>99,-</td>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
    </Container>*/}
        {PilNesteGronn('kontakt')}
    </div>
    
    )
}
export default Tilbud;